function validateTickers(tickers) {
	for (const ticker of tickers) {
		if (ticker.min_weight < 0 || ticker.min_weight > 1) {
			return {
				type: "error",
				message: "Minimum weight must be between 0 and 1",
			};
		} else if (ticker.max_weight < 0 || ticker.max_weight > 1) {
			return {
				type: "error",
				message: "Maximum weight must be between 0 and 1",
			};
		} else if (ticker.max_weight < ticker.min_weight) {
			return {
				type: "error",
				message: "Maximum weight must be greater than minimum weight",
			};
		}
	}
	const minWeightSum = tickers.reduce((acc, curr) => {
		return acc + parseFloat(curr.min_weight);
	}, 0);

	if (minWeightSum >= 1) {
		return {
			type: "warning",
			message: "The sum of minimum weights exceeds 100% of portfolio",
		};
	}
	return true;
}

export { validateTickers };
